import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }

import { ElButton, ElPopover, ElIcon } from 'element-plus'
// @ts-ignore
import size from './size.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'createDesing',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElPopover), {
    placement: "right",
    width: 420,
    trigger: "click",
    "show-arrow": false
  }, {
    reference: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "w-full h-40px flex items-center px-[15px] cursor-pointer" }, "创建设计", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(size)
      ])
    ]),
    _: 1
  }))
}
}

})